import OutdoorRecreation from 'elem/compPage/OutdoorRecreation';
import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';

export default function OutdoorRecreationPage({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const router = useRouter();
    const { locale } = router;
    const WHITE_SITE = ['us', 'ca', 'de', 'za', 'fr', 'eu', 'uk', 'es', 'it', 'au', 'kr'];
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if (!WHITE_SITE.includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed hideToTop theme="white">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={WHITE_SITE} pathname="recreational-activities" />
            <GtmPageLoad />
            <OutdoorRecreation />
        </PageLayout>
    );
}
